window.Layer = function() {
    var el = this;
    
    function findNextLayer(layers, id) {
        var newKey = 0;
        var keys = Object.keys(layers);
        var currentKey = keys.indexOf(id);
        if (currentKey !== keys.length - 1) {
            newKey = currentKey + 1;
            return parseInt(keys[newKey]);
        }
        
        return false;
    }
    
    function findPreviousLayer(layers, id) {
        var newKey = 0;
        var keys = Object.keys(layers);
        var currentKey = keys.indexOf(id);
        
        if (currentKey !== 0) {
            newKey = currentKey - 1;
            return parseInt(keys[newKey]);
        }
        
        return false;
    }
    
    el.add = function(id, type, position) {
        var reversal = el._parent.workData.workareas[id];
        var layers = el.getLayers(id);
        var countLayers = Object.keys(layers).length;
        var newLayerId = 0;
        
        if (countLayers > 0) {
            var lastLayerId = parseInt(Object.keys(layers)[countLayers - 1]);
            newLayerId = lastLayerId + 1;
        }
        
        reversal.layers[newLayerId] = {
            id: position,
            type: type
        };
    };
    
    el.remove = function(id, type, position) {
        var reversal = el._parent.workData.workareas[id];
        
        if (!reversal.hasOwnProperty('layers')) {
            return true;
        }
        
        var layer = {};
        for (var layerId in reversal.layers) {
            layer = reversal.layers[layerId];
            if (layer !== null && layer.id == position && layer.type === type) {
                delete(reversal.layers[layerId]);
                break;
            }
        }
    };
    
    el.replace = function(type, replaceType) {
        //el._parent.svgRoot = document.getElementById('constructor-hardcover');
        console.log(el.selectWorkareaId);
        var reversal = el._parent.workData.workareas[el.selectWorkareaId];
        if (!reversal.hasOwnProperty('layers')) {
            return false;
        }
        
        var srcLayerId, srcLayer = {};
        for (var layerId in reversal.layers) {
            srcLayer = reversal.layers[layerId];
            if (srcLayer !== null && srcLayer.id == el.selectId && srcLayer.type === type) {
                srcLayerId = layerId;
                break;
            }
        }
        
        if (srcLayerId === undefined) {
            return false;
        }
        
        var destLayerId;
        switch(replaceType) {
            case 'up':
                destLayerId = findNextLayer(reversal.layers, srcLayerId);
                break;
            case 'down':
                destLayerId = findPreviousLayer(reversal.layers, srcLayerId);
                break;
        }
        
        if (destLayerId === false) {
            return false;
        }
        
        var tempLayer = $.extend(true, {}, reversal.layers[destLayerId]);
        reversal.layers[destLayerId] = $.extend(true, {}, reversal.layers[srcLayerId]);
        reversal.layers[srcLayerId] = $.extend(true, {}, tempLayer);
        
        switch(type) {
            case 'decors':
                var element = el.svgRoot.getElementById('decors-item-' + el.selectWorkareaId + '-' + el.selectId);
                el.selection.show(element, el.selectWorkareaId, 'decors');
                break;
            case 'cells':
                var element = el.svgRoot.getElementById('grid-cell-' + el.selectWorkareaId + '-' + el.selectId);
                el.selection.show(element, el.selectWorkareaId, 'cell');
                break;
        }
    };
    
    el.getLayers = function(id) {
        var reversal = el._parent.workData.workareas[id];
        if (!reversal.hasOwnProperty('layers')) {
            reversal.layers = {};
            var lastPosition = 0;
            var position, i;
            for (position in reversal.cells) {
                reversal.layers[parseInt(position)] = {
                    id: position,
                    type: 'cells'
                };

                lastPosition = position;
            }

            for (i in reversal.decors) {
                position = parseInt(lastPosition) + parseInt(i);
                reversal.layers[position] = {
                    id: i,
                    type: 'decors'
                };
            }
        }

        return reversal.layers;
    };
    
    el.removeLayers = function(id) {
        var reversal = el._parent.workData.workareas[id];
        if (reversal.hasOwnProperty('layers')) {
            delete(reversal.layers);
        }
    };
    
    el.getTemplateLayers = function(id) {
        var reversal = el._parent.workData.workareas[id];
        var layers = el.getLayers(id);
        var templateLayers = [];
        var templateLayer = {};
        var minRatio = 1;
        for (var i in layers) {
            if (layers[i] === null || !layers[i].hasOwnProperty('id') || !layers[i].hasOwnProperty('type') || reversal[layers[i].type][layers[i].id] === null) {
                continue;
            } 
            
            templateLayer = $.extend(true, {}, reversal[layers[i].type][layers[i].id]);
            templateLayer.id = layers[i].id;
            
            switch(layers[i].type) {
                case 'cells':
                    templateLayer.is_cell = true;
                    templateLayer.is_border_shadow = templateLayer.hasOwnProperty('border_shadow') ? true : false;
                    templateLayer.is_border_opacity = templateLayer.hasOwnProperty('border_opacity') ? true : false;
                    templateLayer.company_id = templateLayer.hasOwnProperty('company_id') ? templateLayer.company_id : window.companyId;
                    templateLayer.center_x = parseInt(templateLayer.x) + parseInt(templateLayer.width / 2);
                    templateLayer.center_y = parseInt(templateLayer.y) + parseInt(templateLayer.height / 2);
                    if (reversal.images.hasOwnProperty(layers[i].id) && reversal.images[layers[i].id] !== null) {
                        templateLayer.image = $.extend(true, {}, reversal.images[layers[i].id]);
                        templateLayer.image.company_id = templateLayer.image.hasOwnProperty('company_id') ? templateLayer.image.company_id : window.companyId;
                        templateLayer.image.id = layers[i].id;
                        switch (templateLayer.image.type) {
                            case 'custom':
                                templateLayer.image.url = window.location.origin + el.projectsPath + '/' + window.bookSid + '/workimages/' + templateLayer.image.name;
                                break;
                            case 'template':
                                templateLayer.image.url = window.location.protocol + '//' + window.location.hostname + '/img/uploaded/bc/templates/' + templateLayer.image.theme_id + '/workimages/' + templateLayer.image.name;
                                break;
                        }
                        
                        minRatio = el.format.items[reversal.format_id].min_ratio;
                        
                        if (templateLayer.width * el.workData.scale / templateLayer.image.data_width >= minRatio || templateLayer.width * el.workData.scale / templateLayer.image.data_height >= minRatio) {
                            templateLayer.image.is_low_resolution = true;
                        }
                        
                        if (templateLayer.hasOwnProperty('rotate_angle') && templateLayer.image.hasOwnProperty('mask')) {
                            templateLayer.image.mask_rotate_angle = -parseFloat(templateLayer.image.rotate_angle);
                        }
                    }
                    break;
                case 'decors':
                    templateLayer.is_decor = true;
                    templateLayer.company_id = templateLayer.hasOwnProperty('company_id') ? templateLayer.company_id : window.companyId;
                    break;
            }
            
            templateLayers.push(templateLayer);
        }
        
        return templateLayers;
    };
};